var _path, _path2, _g, _path3, _path4, _rect, _g2, _circle, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAnswerDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 63.4954H129.44V118C129.44 124.075 124.515 129 118.44 129H40C33.9249 129 29 124.075 29 118V63.4954Z",
    fill: "#FF6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0132 20.8727C74.543 14.9822 83.8973 14.9822 89.4272 20.8727L129.44 63.4954L29 63.4954L69.0132 20.8727Z",
    fill: "#FF6262"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2092_18699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.1929,
    y: 35.1101,
    width: 70.9633,
    height: 90.6147,
    rx: 12,
    fill: "#FFF3F3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.431 129L40 129C33.9249 129 29 124.075 29 118L29 63.4954L117.431 129Z",
    fill: "#FFA9A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0093 129L118.44 129C124.516 129 129.44 124.075 129.44 118L129.44 63.4954L41.0093 129Z",
    fill: "#FFA9A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2092_18699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 63,
    width: 101,
    height: 66
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.44,
    y: 129,
    width: 100.44,
    height: 65.5046,
    rx: 11,
    transform: "rotate(-180 129.44 129)",
    fill: "url(#paint0_linear_2092_18699)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2092_18699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7331 92.5689C76.2984 88.4551 83.2338 88.4551 87.7991 92.5689L129.44 130.092L30.0918 130.092L71.7331 92.5689Z",
    fill: "url(#paint1_linear_2092_18699)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.22,
    cy: 63.4954,
    r: 14.1927,
    fill: "#FF6262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1235 62.3525L77.0475 67.0439L86.3162 58.7649",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2092_18699",
    x: 33.1929,
    y: 25.1101,
    width: 90.9634,
    height: 110.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.594262 0 0 0 0 0.593125 0 0 0 0 0.65 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2092_18699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2092_18699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_18699",
    x1: 179.661,
    y1: 129,
    x2: 179.661,
    y2: 194.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2092_18699",
    x1: 79.7661,
    y1: 85.3303,
    x2: 79.7661,
    y2: 130.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F8F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAnswerDone);
export default __webpack_public_path__ + "static/media/img_answer_done.2ace6a66f373525e08f1bb2479f9b726.svg";
export { ForwardRef as ReactComponent };